import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { FeedGridService } from '../shared/feed-grid.service';
import { PagerLocation } from '../feed-grid/pager-location.model';
import { FeedSelectorConfiguration } from '../shared/models/feed-selector-configuration.model';
import { EventLoggerService } from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';
import { DataMinerUiError } from '../../../shared/error-handling/error-detail.model';

@Component({
    selector: 'feed-grid-selector',
    templateUrl: './feed-grid-selector.component.html',
    styleUrls: ['./feed-grid-selector.component.css'],
    providers: [FeedGridService]
})
export class FeedGridSelectorComponent implements OnInit {
    title: string;
    identityField: string;
    displayField: string;
    selectorValues: string[];
    pagerLocation: PagerLocation = PagerLocation.Bottom;
    selectListItemsObservable: Observable<any[]>;
    selectListItems: any[] = [];
    selectedGridRows: any[] = [];
    selectedSelectListItems: any[] = [];
    topFilterBoxExists: boolean;
    selectorConfig: FeedSelectorConfiguration;
    selectedRowsSubscription: Subscription;
    error: any;
    errorKey = 'feed-grid-selector';

    constructor(private gridService: FeedGridService, private eventLogger: EventLoggerService, private errorManager: ErrorManagerService) {
        this.gridService.metadataDetailObservable.subscribe(detail => {
            this.title = detail.displayName;
            if (detail.feedSelectorConfiguration) {
                this.identityField = detail.feedSelectorConfiguration.sourceIdentityField;
                this.displayField = detail.feedSelectorConfiguration.sourceDisplayField;
                this.selectorConfig = detail.feedSelectorConfiguration;
            }
        });
        this.gridService.selectedGridRowsObservable.subscribe(rows => {
            this.selectedGridRows = rows;
        });
        this.selectListItemsObservable = this.gridService.selectedSelectListRowsObservable;
        this.gridService.topFilterBoxObservable.subscribe(res => this.topFilterBoxExists = res);

    }

    ngOnInit(): void {
        this.clearError();
        const detail = this.gridService.getDetailsFromParent();
        if (detail && detail.selectedRows) {
            this.selectListItems = detail.selectedRows.slice(0);
        }
    }

    subscribeFeedGridError() {
        const error = new DataMinerUiError();
        error.message = 'Unable to get feed pricing nodes';
        error.detailedMessage = error.message;
        this.error = error;
    }

    onAddSelectedGridRowsToSelectList(): void {

        this.selectedGridRows.forEach(gridRow => {
            const id = gridRow[this.identityField];
            const item = this.selectListItems.find(x => x[this.identityField] === id);
            if (!item) {
                this.selectListItems.push(gridRow);
            }
        });
        this.gridService.setSelectListRows(this.selectListItems);
    }

    onRemoveSelectListItems(): void {
        const temp = this.selectedSelectListItems.slice(0);
        temp.forEach(item => {
            const id = item[this.identityField];
            // Remove from select list
            let found = this.selectListItems.find(x => x[this.identityField] === id);
            if (found) {
                const index = this.selectListItems.indexOf(found);
                this.selectListItems.splice(index, 1);
            }
            // remove from selected
            found = this.selectedSelectListItems.find(x => x[this.identityField] === id);
            if (found) {
                const index = this.selectedSelectListItems.indexOf(found);
                this.selectedSelectListItems.splice(index, 1);
            }
        });
        // notify subscribers
        this.gridService.setSelectListRows(this.selectListItems);
    }

    selectListItemIsSelected(item: any) {
        const id = item[this.identityField];
        return this.selectedSelectListItems.find(x => x[this.identityField] === id) !== undefined;
    }

    onToggleSelectListItemSelection(item: any) {
        const id = item[this.identityField];
        const selectListItem = this.selectedSelectListItems.find(x => x[this.identityField] === id);
        if (!selectListItem) {
            // Not there? add it
            this.selectedSelectListItems.push(item);
        } else {
            // there? remove it.
            const index = this.selectedSelectListItems.indexOf(item);
            this.selectedSelectListItems.splice(index, 1);
        }
    }

    onSubmit(): void {
        this.gridService.updateParent(this.selectorConfig.feedKey, this.selectedGridRows);
        window.close();
    }

    onClear(): void {
        this.selectListItems = [];
        this.selectedSelectListItems = [];
        // notify subscribers
        this.gridService.setSelectListRows(this.selectListItems);
    }

    onCancel(): void {
        window.close();
    }

    clearError() {
        this.errorManager.removeDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey);
    }

    handleError(error: any) {
        const FeedPnodeNoResponse = 'An unexpected error occurred. Please try again.';
        this.errorManager.saveDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey, error, FeedPnodeNoResponse);
        this.eventLogger.logError(new Error(this.errorManager.dataMinerUiError.message), this.errorManager.dataMinerUiError.message, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-grid-selector/feed-grid-selector.component.ts